import { render, staticRenderFns } from "./VerifyTelField.vue?vue&type=template&id=34d4ae3a&scoped=true"
import script from "./VerifyTelField.vue?vue&type=script&lang=js"
export * from "./VerifyTelField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4ae3a",
  null
  
)

export default component.exports